"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EdgeIntersectionList = _interopRequireDefault(require("./EdgeIntersectionList"));

var _IntersectionMatrix = _interopRequireDefault(require("../geom/IntersectionMatrix"));

var _MonotoneChainEdge = _interopRequireDefault(require("./index/MonotoneChainEdge"));

var _Position = _interopRequireDefault(require("./Position"));

var _Coordinate = _interopRequireDefault(require("../geom/Coordinate"));

var _Label = _interopRequireDefault(require("./Label"));

var _Envelope = _interopRequireDefault(require("../geom/Envelope"));

var _StringBuilder = _interopRequireDefault(require("../../../../java/lang/StringBuilder"));

var _Depth = _interopRequireDefault(require("./Depth"));

var _GraphComponent2 = _interopRequireDefault(require("./GraphComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Edge =
/*#__PURE__*/
function (_GraphComponent) {
  _inherits(Edge, _GraphComponent);

  function Edge() {
    var _this;

    _classCallCheck(this, Edge);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Edge).call(this));
    Edge.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(Edge, [{
    key: "getDepth",
    value: function getDepth() {
      return this._depth;
    }
  }, {
    key: "getCollapsedEdge",
    value: function getCollapsedEdge() {
      var newPts = new Array(2).fill(null);
      newPts[0] = this.pts[0];
      newPts[1] = this.pts[1];
      var newe = new Edge(newPts, _Label.default.toLineLabel(this._label));
      return newe;
    }
  }, {
    key: "isIsolated",
    value: function isIsolated() {
      return this._isIsolated;
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      return this.pts;
    }
  }, {
    key: "setIsolated",
    value: function setIsolated(isIsolated) {
      this._isIsolated = isIsolated;
    }
  }, {
    key: "setName",
    value: function setName(name) {
      this._name = name;
    }
  }, {
    key: "equals",
    value: function equals(o) {
      if (!(o instanceof Edge)) return false;
      var e = o;
      if (this.pts.length !== e.pts.length) return false;
      var isEqualForward = true;
      var isEqualReverse = true;
      var iRev = this.pts.length;

      for (var i = 0; i < this.pts.length; i++) {
        if (!this.pts[i].equals2D(e.pts[i])) {
          isEqualForward = false;
        }

        if (!this.pts[i].equals2D(e.pts[--iRev])) {
          isEqualReverse = false;
        }

        if (!isEqualForward && !isEqualReverse) return false;
      }

      return true;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      if (arguments.length === 0) {
        if (this.pts.length > 0) return this.pts[0];
        return null;
      } else if (arguments.length === 1) {
        var i = arguments[0];
        return this.pts[i];
      }
    }
  }, {
    key: "print",
    value: function print(out) {
      out.print("edge " + this._name + ": ");
      out.print("LINESTRING (");

      for (var i = 0; i < this.pts.length; i++) {
        if (i > 0) out.print(",");
        out.print(this.pts[i].x + " " + this.pts[i].y);
      }

      out.print(")  " + this._label + " " + this._depthDelta);
    }
  }, {
    key: "computeIM",
    value: function computeIM(im) {
      Edge.updateIM(this._label, im);
    }
  }, {
    key: "isCollapsed",
    value: function isCollapsed() {
      if (!this._label.isArea()) return false;
      if (this.pts.length !== 3) return false;
      if (this.pts[0].equals(this.pts[2])) return true;
      return false;
    }
  }, {
    key: "isClosed",
    value: function isClosed() {
      return this.pts[0].equals(this.pts[this.pts.length - 1]);
    }
  }, {
    key: "getMaximumSegmentIndex",
    value: function getMaximumSegmentIndex() {
      return this.pts.length - 1;
    }
  }, {
    key: "getDepthDelta",
    value: function getDepthDelta() {
      return this._depthDelta;
    }
  }, {
    key: "getNumPoints",
    value: function getNumPoints() {
      return this.pts.length;
    }
  }, {
    key: "printReverse",
    value: function printReverse(out) {
      out.print("edge " + this._name + ": ");

      for (var i = this.pts.length - 1; i >= 0; i--) {
        out.print(this.pts[i] + " ");
      }

      out.println("");
    }
  }, {
    key: "getMonotoneChainEdge",
    value: function getMonotoneChainEdge() {
      if (this._mce === null) this._mce = new _MonotoneChainEdge.default(this);
      return this._mce;
    }
  }, {
    key: "getEnvelope",
    value: function getEnvelope() {
      if (this._env === null) {
        this._env = new _Envelope.default();

        for (var i = 0; i < this.pts.length; i++) {
          this._env.expandToInclude(this.pts[i]);
        }
      }

      return this._env;
    }
  }, {
    key: "addIntersection",
    value: function addIntersection(li, segmentIndex, geomIndex, intIndex) {
      var intPt = new _Coordinate.default(li.getIntersection(intIndex));
      var normalizedSegmentIndex = segmentIndex;
      var dist = li.getEdgeDistance(geomIndex, intIndex);
      var nextSegIndex = normalizedSegmentIndex + 1;

      if (nextSegIndex < this.pts.length) {
        var nextPt = this.pts[nextSegIndex];

        if (intPt.equals2D(nextPt)) {
          normalizedSegmentIndex = nextSegIndex;
          dist = 0.0;
        }
      }

      var ei = this.eiList.add(intPt, normalizedSegmentIndex, dist);
    }
  }, {
    key: "toString",
    value: function toString() {
      var builder = new _StringBuilder.default();
      builder.append("edge " + this._name + ": ");
      builder.append("LINESTRING (");

      for (var i = 0; i < this.pts.length; i++) {
        if (i > 0) builder.append(",");
        builder.append(this.pts[i].x + " " + this.pts[i].y);
      }

      builder.append(")  " + this._label + " " + this._depthDelta);
      return builder.toString();
    }
  }, {
    key: "isPointwiseEqual",
    value: function isPointwiseEqual(e) {
      if (this.pts.length !== e.pts.length) return false;

      for (var i = 0; i < this.pts.length; i++) {
        if (!this.pts[i].equals2D(e.pts[i])) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "setDepthDelta",
    value: function setDepthDelta(depthDelta) {
      this._depthDelta = depthDelta;
    }
  }, {
    key: "getEdgeIntersectionList",
    value: function getEdgeIntersectionList() {
      return this.eiList;
    }
  }, {
    key: "addIntersections",
    value: function addIntersections(li, segmentIndex, geomIndex) {
      for (var i = 0; i < li.getIntersectionNum(); i++) {
        this.addIntersection(li, segmentIndex, geomIndex, i);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return Edge;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "updateIM",
    value: function updateIM() {
      if (arguments.length === 2 && arguments[1] instanceof _IntersectionMatrix.default && arguments[0] instanceof _Label.default) {
        var label = arguments[0],
            im = arguments[1];
        im.setAtLeastIfValid(label.getLocation(0, _Position.default.ON), label.getLocation(1, _Position.default.ON), 1);

        if (label.isArea()) {
          im.setAtLeastIfValid(label.getLocation(0, _Position.default.LEFT), label.getLocation(1, _Position.default.LEFT), 2);
          im.setAtLeastIfValid(label.getLocation(0, _Position.default.RIGHT), label.getLocation(1, _Position.default.RIGHT), 2);
        }
      } else return _get(_getPrototypeOf(Edge), "updateIM", this).apply(this, arguments);
    }
  }]);

  return Edge;
}(_GraphComponent2.default);

exports.default = Edge;

Edge.constructor_ = function () {
  this.pts = null;
  this._env = null;
  this.eiList = new _EdgeIntersectionList.default(this);
  this._name = null;
  this._mce = null;
  this._isIsolated = true;
  this._depth = new _Depth.default();
  this._depthDelta = 0;

  if (arguments.length === 1) {
    var pts = arguments[0];
    Edge.constructor_.call(this, pts, null);
  } else if (arguments.length === 2) {
    var _pts = arguments[0],
        label = arguments[1];
    this.pts = _pts;
    this._label = label;
  }
};